import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const commsService = {
  listNotifications: async (unreadOnly = false) => {
    const response = await api.get('/comms/notifications', {
      params: { unreadOnly: unreadOnly ? 'true' : undefined },
    });
    return response.data;
  },
  unreadCount: async () => {
    const response = await api.get('/comms/notifications/unread-count');
    return response.data;
  },
  markRead: async (id) => {
    const response = await api.patch(`/comms/notifications/${id}/read`);
    return response.data;
  },
  markAllRead: async () => {
    const response = await api.post('/comms/notifications/mark-all-read');
    return response.data;
  },
  listComments: async (targetType, targetId) => {
    const response = await api.get('/comms/comments', {
      params: { targetType, targetId },
    });
    return response.data;
  },
  addComment: async (data) => {
    const response = await api.post('/comms/comments', data);
    return response.data;
  },
  resolveComment: async (id) => {
    const response = await api.patch(`/comms/comments/${id}/resolve`);
    return response.data;
  },
  listTasks: async (status) => {
    const response = await api.get('/comms/tasks', { params: { status } });
    return response.data;
  },
  createTask: async (data) => {
    const response = await api.post('/comms/tasks', data);
    return response.data;
  },
  updateTask: async (id, data) => {
    const response = await api.patch(`/comms/tasks/${id}`, data);
    return response.data;
  },
  scanMissingNotes: async () => {
    const response = await api.post('/comms/tasks/scan-missing-notes');
    return response.data;
  },
  listAppointmentRequests: async (status) => {
    const response = await api.get('/comms/appointment-requests', { params: { status } });
    return response.data;
  },
  updateAppointmentRequest: async (id, data) => {
    const response = await api.patch(`/comms/appointment-requests/${id}`, data);
    return response.data;
  },
  listReminders: async () => {
    const response = await api.get('/comms/reminders');
    return response.data;
  },
  runReminders: async () => {
    const response = await api.post('/comms/reminders/run');
    return response.data;
  },
};

export default commsService;
